import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { IActionExecutor } from '@organisms/actions/IActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { ICreateAttachVersionProps } from './ICreateAttachVersionProps';
import { CreateAttachVersionModal } from './CreateAttachVersionModal';

export class CreateAttachVersionExecutor implements IActionExecutor {
    private _modalProps?: ICreateAttachVersionProps;

    run = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        raiseVisualElement?: () => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: parentId ?? '',
            attachId: objId,
            rowData: rowData,
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'xl',
            completeHandler: completeHandler,
        };
    };

    visualElement = () => {
        return this._modalProps ? <CreateAttachVersionModal {...this._modalProps} /> : <div />;
    };
}
